export class ClassMemberNullError extends Error {
    /**
     * @param {String} classMemberName
     * @param {String} caller
     */
    constructor(classMemberName, caller) {
        super(`Class member ${classMemberName} cannot be null (caller: ${caller})`)
    }

    /**
     * 
     * @param {any} classMemberValue
     * @param {String} classMemberName
     * @param {String} caller
     */
    static throw(classMemberValue, classMemberName, caller) {
        if (classMemberValue == undefined || classMemberValue == null)
            throw new ClassMemberNullError(classMemberName, caller)
    }
}
